import loginFormTemplate from "./login_form_template.js";
import registerFormTemplate from "./register_form_template.js";
import otherFormsTemplate from "./other_forms_template.js";

export default `
    <div id="section-content" v-bind:class="['section-subscription', 'step-' + current, { 'legacy': current != 'login' && current != 'register' }]" v-if="current"
        :style="'background-image: url(' + ajax_var.base_uri + '/assets/images/' + pages[current].pageBackground + ');'">
        <router-link v-if="current == 'register'" to="/login" class="login-link">Login</router-link>
        <div class="background-overlay" v-if="current != 'video'"></div>
    
        ${registerFormTemplate}
        
        ${loginFormTemplate}
        
        ${otherFormsTemplate}
        
        <div id="g-rec-login-signup-form" class="g-recaptcha-invisible" :data-sitekey="ajax_var.recaptcha_site_key" data-callback="lumRecaptchaCallback" data-size="invisible"></div>
    
        <div class="popup-overlay" @click="carrotOpened = false" v-show="carrotOpened && userStatus"></div>
        <div v-show="carrotOpened && userStatus" :class="{ 'gs-popup-wrap':carrotOpened && userStatus, 'gs-pop-subscription':carrotOpened && userStatus }" :style="{}">
            <a href="#" class="pop-close" @click="carrotOpened = false"> </a>
            <div class="pop-bubble">
                <strong>Before you get started,</strong> watch this short video tutorial to learn how to use Hortisketch!
                <button @click="goToVideo" class="btn btn-popup">WATCH VIDEO</button>
            </div>
            <div class="carrot"> 
                <img :src="ajax_var.general_assets + 'images/carrot.svg'" alt="carrot" />
            </div>
        </div>
    </div>
`;
